import React, { Fragment } from 'react';
import { isNull } from 'lodash';
import Table from '../../../../components/_table/Table';
import Button from '../../../../components/Button';
import BaseForm from '../../../../components/form/BaseForm';
import Input from '../../../../components/input/Input';
import Select from '../../../../components/input/Select';
import columns from './columns';
import { addAllItemToSelectList } from '../../../../lib/common';
import {
  POINT_LOG_TYPE,
  MAXIMUM_NUMBER_OF_AMOUNT,
  MINIMUM_NUMBER_OF_AMOUNT,
  POINT_LOG_TYPE_SELECT_LIST,
  POINT_GENERATE_PAGE_SECTION_NAME,
} from '../../../../constants/service/app/pointConstants';
import './PointGenerateSelectedUserList.scss';

const PointGenerateSelectedUserList = (props) => {
  const {
    pointCauseSelectList,
    setData,
    selectedUserInfoList,
    onCheckUser,
    selectedUserIdList,
    form,
    initCause,
    applyBulkPointInfo,
    pointBulkApply,
  } = props;

  return (
    <div
      className="point-generate-selected-user-list"
      name={POINT_GENERATE_PAGE_SECTION_NAME.POINT_GENERATE_SELECTED_USER_LIST}
    >
      <div className="point-generate-selected-user-list-bulk-apply">
        <BaseForm
          label="일괄 설정"
          content={
            <Fragment>
              {/*발급 내역 타입*/}
              <Select
                list={POINT_LOG_TYPE_SELECT_LIST}
                value={pointBulkApply.type}
                onChange={(value) => {
                  setData({
                    path: ['pointBulkApply', 'type'],
                    value,
                  });
                  setData({
                    path: ['pointBulkApply', 'pointCauseId'],
                    value: null,
                  });
                }}
              />

              {/*적립/사용처 선택*/}
              <Select
                placeholder={'적립/사용처'}
                list={
                  pointBulkApply.type === POINT_LOG_TYPE.SAVE
                    ? addAllItemToSelectList(
                        pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.SAVE),
                        '적립/사용처',
                      )
                    : addAllItemToSelectList(
                        pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.USE),
                        '적립/사용처',
                      )
                }
                value={pointBulkApply.pointCauseId}
                disabled={isNull(pointBulkApply.type)}
                onChange={(value) => {
                  setData({
                    path: ['pointBulkApply', 'pointCauseId'],
                    value,
                  });
                }}
              />

              {/*액수*/}
              <Input
                placeholder={'액수'}
                value={pointBulkApply.amount}
                type="number"
                onChange={(value) => {
                  if (value >= MINIMUM_NUMBER_OF_AMOUNT && value <= MAXIMUM_NUMBER_OF_AMOUNT) {
                    setData({
                      path: ['pointBulkApply', 'amount'],
                      value,
                    });
                  }
                }}
              />

              {/*누르면 type, pointCauseId, amount 일괄 변경*/}
              <Button text="선택건 적용" color="primary" onClick={() => applyBulkPointInfo()} />
            </Fragment>
          }
        />
      </div>

      <div className="selected-user-cnt">선택한 유저 목록 ({selectedUserIdList.length})</div>

      <div className="selected-user-info-list">
        <Table
          list={selectedUserInfoList}
          showPagination={false}
          rowKey={(record) => record.userId}
          selectedList={selectedUserIdList}
          onCheck={(list) => onCheckUser(list)}
          scroll={{ x: true }}
          columns={(utils) =>
            columns({
              pointCauseSelectList,
              selectedUserInfoList,
              setData,
              form,
              initCause,
              ...utils,
            })
          }
        />
      </div>
    </div>
  );
};

export default PointGenerateSelectedUserList;
